// Services
import api from '../../services/api';

const state = {
  tags: [],
  selectedTags: [],
};

const getters = {
  getTags: (state) => state.tags,
  getSelectedTags: (state) => state.selectedTags,
};

const actions = {
  fetchTags: ({ commit }) =>
    new Promise(async (resolve, reject) => {
      try {
        const { data: respData, status } = await api({
          url: '/api/tags/',
          method: 'GET',
        });
        

        if (status === 200) {
          // add selected: false to each tag
          respData.results.forEach((tag) => {
            tag.hidden = false;
          });

          commit('setTags', respData.results);
        } else {
          return resolve();
        }

      } catch (e) {
        reject(e);
      }
    }),

    setTags: ({ commit }, tags) => {
      commit('setTags', tags);
    },
    setSelectedTags: ({ commit }, tags) => {
      commit('setSelectedTags', tags);
    },
    addSelectedTag: ({ commit }, tag) => {
      commit('addSelectedTag', tag);
    },
    removeSelectedTag: ({ commit }, tag) => {
      commit('removeSelectedTag', tag);
    },
    resetSelectedTags: ({ commit }) => {
      commit('resetSelectedTags');
    },
};

const mutations = {
  setTags: (state, tags) => {
    state.tags = tags;
  },
  setSelectedTags: (state, tags) => {
    state.selectedTags = tags;
  },
  addSelectedTag: (state, tag) => {
    state.selectedTags.push(tag);
  },
  removeSelectedTag: (state, tag) => {
    state.selectedTags = state.selectedTags.filter((t) => t.id !== tag.id);
  },
  resetSelectedTags: (state) => {
    state.selectedTags = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
